import clsx from 'clsx'
import map from 'lodash/map'
import React, { FC, useId } from 'react'

import SvgClubTrendhim from '@Assets/SVG/ClubTrendhim'
import { CommonContent } from '@Components/CommonContent'
import { RTEContent } from '@Components/RTEContent'
import { Wordbook } from '@Components/Wordbook'
import { AccordionListBlock as AccordionListBlockGraphQL, BlockCommon } from '@Generated/graphql'
import { getRTEFieldText } from '@Globals/CMS/FieldHelpers'
import { useTranslation } from '@Globals/Translations'

import { AccordionItem, HeaderWithAccordionItems } from '../../../../CoreComponents/Accordions/HeaderWithAccordion'
import styles from './AccordionListBlock.module.scss'

interface AccordionListBlockProps {
  accordionListBlock: AccordionListBlockGraphQL
  id?: string
  isInModal?: boolean
}

const AccordionListBlock: FC<AccordionListBlockProps> = ({ accordionListBlock, id, isInModal }) => {
  const { t } = useTranslation()
  const itemID = useId()
  if (!accordionListBlock?.accordions || accordionListBlock.accordions.length === 0) {
    return null
  }

  if (accordionListBlock.appearance?.backgroundColor || accordionListBlock.appearance?.textColor || accordionListBlock.common?.title) {
    return (
      <HeaderWithAccordionItems
        backgroundColor={accordionListBlock.appearance?.backgroundColor || 'var(--neutral-100)'}
        className={clsx(isInModal && styles.isInModal)}
        commonContent={<CommonContent common={accordionListBlock.common as BlockCommon} />}
        textColor={accordionListBlock.appearance?.textColor || 'var(--black)'}
      >
        {map(accordionListBlock.accordions, (accordion) => {
          const content = getRTEFieldText(accordion?.fields || [], 'content')
          return (
            <AccordionItem
              key={`club_faq_accordion${accordion.title}`}
              className={styles.trendhimClubAccordion}
              header={accordion.title}
              id={`club_faq_accordion${accordion.title}`}
            >
              {content && <RTEContent html={content} />}
            </AccordionItem>
          )
        })}
      </HeaderWithAccordionItems>
    )
  }
  if (accordionListBlock.id === '17') {
    return (
      <HeaderWithAccordionItems
        backgroundColor="var(--neutral-100)"
        className={clsx(isInModal && styles.isInModal)}
        text={<i>{t('common:TRENDHIMCLUB_LOWER_FREE_SHIPPING_THRESHOLD')}</i>}
        textColor="var(--black)"
        title={(
          <Wordbook
            components={{ TrendhimClubIcon: <SvgClubTrendhim className={styles.trendhimClubFaqSvg} /> }}
            wordbook={{ defaults: t('club2:TRENDHIMCLUB_FAQ_TITLE', '<TrendhimClubIcon/> FAQ') }}
          />
        )}
      >
        {map(accordionListBlock.accordions, (accordion) => {
          const content = getRTEFieldText(accordion?.fields || [], 'content')
          return (
            <AccordionItem
              key={`club_faq_accordion${accordion.title}`}
              className={styles.trendhimClubAccordion}
              header={accordion.title}
              id={`club_faq_accordion${accordion.title}`}
            >
              {content && <RTEContent html={content} />}
            </AccordionItem>
          )
        })}
      </HeaderWithAccordionItems>
    )
  }

  return (
    <div id={id} style={{ display: 'flex', flexDirection: 'column', maxWidth: '1200px' }}>
      {map(accordionListBlock.accordions, (item) => {
        const content = getRTEFieldText(item?.fields || [], 'content')

        return (
          <AccordionItem key={item.title} header={item.title} id={`_accordionListBlock_${itemID}_${id}_${item.title?.replaceAll(' ', '_')}`}>
            {content && <RTEContent html={content} />}
          </AccordionItem>
        )
      })}
    </div>
  )
}

export default AccordionListBlock
